import { sessionStorageGet } from "@/utils/sessionStorage";
import { updateBookingInfoToken } from "@/apiCalls/bookingInfoToken";
import { BookingFieldGroup } from "types";
import { rollbar } from "../../../rollbar";

export async function updateBookingInfo(
  bookingStore,
  app: string,
  searchToken,
) {
  const noEntityForms = bookingStore.sortedBookingForms.filter(
    (form: BookingFieldGroup) => {
      return form.booking_field_group_type !== "insured_entity";
    },
  );
  const tokenPayload = {
    booking_info_token: {
      payload: {
        payer: bookingStore.payer,
        policy_holder: bookingStore.policy_holder,
        payment_method: bookingStore.payment_method,
        policy_holder_insured:
          bookingStore.policy_holder?.copy_policyholder_data ?? false,
        insured_entity: bookingStore.insured_entity,
        search_token: searchToken,
      },
    },
  };
  noEntityForms.forEach((form: BookingFieldGroup) => {
    const formName =
      form.booking_field_group_type === "tariff"
        ? form.booking_field_group_type + form.id
        : form.booking_field_group_type;

    tokenPayload.booking_info_token.payload[formName] =
      bookingStore.$state[formName];
  });
  const tokenId = sessionStorageGet(`${app}_booking_info_token`) || "";
  if (!tokenId) return;
  await updateBookingInfoToken(tokenId, tokenPayload);
}

export function updateBookingInfoWithMissingForms(
  bookingStore,
  token: string,
  _app: string,
) {
  if (!token) return;
  let tokenParsed;
  try {
    tokenParsed = JSON.parse(token);
  } catch (e) {
    rollbar?.error(e as Error, {
      context: "updateBookingInfoToken:parseToken",
    });
    return;
  }
  if (!tokenParsed || typeof tokenParsed !== "object") return;

  const tokenParsedKeys = Object.keys(tokenParsed);
  const missingForms = bookingStore.bookingForms.filter(
    (form: BookingFieldGroup) => {
      return !tokenParsedKeys.includes(form.booking_field_group_type);
    },
  );
  if (missingForms.length < 1) return;
  missingForms.forEach((form: BookingFieldGroup) => {
    if (form.booking_field_group_type === "tariff") {
      return;
    }
    const formName =
      form.booking_field_group_type === "tariff"
        ? form.booking_field_group_type + form.id
        : form.booking_field_group_type;
    if (form.booking_field_group_type !== "insured_entity") {
      if (bookingStore.$state[formName] !== undefined) {
        tokenParsed[formName] = bookingStore.$state[formName];
      }
    } else {
      if (bookingStore.insured_entity !== undefined) {
        tokenParsed.insured_entity = bookingStore.insured_entity;
      }
    }
  });
}
